import {Component, signal, ViewEncapsulation} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ChatComponent} from "../app/components/chat/chat.component";
import {IconsModule} from "@thx/ui/icons";
import {ChatbotThemeService} from "../app/services/theme.service";
import {NzIconDirective} from "ng-zorro-antd/icon";
import {convict} from "../app/config/convict-env.config";


@Component({
  selector: 'chatbot-widget',
  standalone: true,
  imports: [CommonModule, ChatComponent, IconsModule, NzIconDirective],
  templateUrl: './widget.component.html',
  styleUrl: './widget.component.less',
  encapsulation: ViewEncapsulation.None
})
export class WidgetComponent {
  isOpen = signal(false);
  homepageUrl = convict.homepageUrl;

  constructor(private readonly _themeService: ChatbotThemeService) {
  }


  get theme() {
    return this._themeService._currentTheme;
  }
}
